import i18n, { loadLanguageAsync } from '@/i18n';

export const t = (key: string, params?: Record<string, unknown> | any[]): string => {
  const normalizedKey = String(key).toLowerCase();
  const opts =
    params === undefined || (Array.isArray(params) && params.length === 0) ? {} : params;
  return (i18n.global.t(normalizedKey, opts as any) as string) || key;
};

const interpolateList = (message: string, list: unknown[]): string =>
  message.replace(/\{(\d+)\}/g, (fullMatch, index) => {
    const value = list[Number(index)];
    if (value || value === 0) {
      return String(value);
    }
    return fullMatch;
  });

export function tc(key: string, choice: number, list?: unknown[]): string {
  const normalizedKey = `____plural.${String(key).toLowerCase()}`;
  const hasList = list != null && list.length > 0;
  const translated = hasList
    ? String(i18n.global.t(normalizedKey, list, { plural: choice }) || '')
    : String(i18n.global.t(normalizedKey, choice) || '');
  if (hasList && translated.includes('{')) {
    return interpolateList(translated, list) || key;
  }
  return translated || key;
}

export function useI18n() {
  return {
    loadLanguageAsync,
    t,
    tc,
    locale: i18n.global.locale,
  };
}
